import { Avatar, Box, ImageListItemBar } from "@mui/material";
import React, { Component } from "react";

import { getAuth, updateProfile } from "firebase/auth";
import { app } from "../../../firebase";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { StarIcon } from "@heroicons/react/outline";
import CircularProgress from "@mui/material/CircularProgress";
import ViewProducts from "../../products/ViewProducts";

import {
  getDatabase,
  ref,
  onValue,
  push,
  onDisconnect,
  set,
  serverTimestamp,
  get,
  child,
} from "firebase/database";
import {
  doc,
  getDocs,
  getFirestore,
  collection,
  onSnapshot,
  query,
  getDoc,
  setDoc,
} from "firebase/firestore";

export class ProductPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      name: "",
      id: "",
      open: true,
      productModal: false,
      modalOpen: {},
      users: [],
    };
  }

  componentDidMount() {
    this.getUser();
  }

  getUser = () => {
    const db = getFirestore(app);
    const q = query(collection(db, "users"));
    let list = [];

    const unsubcribe = onSnapshot(q, (querySnapshot) => {
      console.log(querySnapshot);
      querySnapshot.forEach((doc) => {
        let users;
        users = { id: doc.id, data: doc.data() };

        list.push(users);
      });
      console.log(list);

      this.setState({ users: list });
    });
  };
  productModal = (e) => {
    this.setState({ productModal: true, modalOpen: e });
  };

  srcset = (image, width, height, rows = 1, cols = 1) => {
    return {
      src: `${image}?auto=format`,
      srcSet: `${image}?&auto=format&dpr=2 2x`,
    };
  };

  render() {
    const products = this.props.products;
    if (products == null) {
      return (
        <Box className="w-full h-full flex items-center justify-center">
          <CircularProgress size={50} />
        </Box>
      );
    } else if (products == []) {
      return (
        <Box className="w-full h-full flex items-center justify-center">
          Visit the market page to see cool stuffs
        </Box>
      );
    } else {
      return (
        <Box>
          <Box>Your sellers</Box>
          <Box className="p-2 w-full grid grid-rows-auto   lg:grid-cols-3  gap-2">
            {products.map((product) => {
              return (
                <Box
                  key={`${Math.random().toString(36).substring(2, 9)}odezssa`}
                  className="max-h-max min-h-min h-min  lg:w-full   rounded-md p-2 bg-white shadow-md bg-slate-50"
                >
                  <div className="  h-max ">
                    {this.state.users.map((user) => {
                      if (user.id === product.id)
                        return (
                          <div className="flex gap-1 items-center">
                            {" "}
                            <div className="flex ">
                              <Avatar src={user.data.photoURL} size="small" />
                            </div>
                            <div>
                              {" "}
                              <p
                                className="truncate text-ellipsis  "
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: " nowrap",
                                }}
                              >
                                {user.data.displayName}
                              </p>
                            </div>
                          </div>
                        );
                    })}
                  </div>
                  <div className="flex justify-center">
                    <img
                      className="rounded-md b-2 "
                      src={product.uri}
                      style={{
                        objectFit: "contain ",
                        height: "320px",
                        objectPosition: "center",
                        width: "320px",
                      }}
                    />
                  </div>
                  <div className="flex justify-between items-center w-full mt-2">
                    <div className=" w-full  ">
                      <div>
                        <div className="font-bold text-gray-500">
                          {product.pName}
                        </div>{" "}
                        <p className="font-medium text-gray-500 text-md  ">
                          {product.descrip}
                        </p>
                      </div>
                      <div className="flex  w-full justify-end">
                        <p className=" text-gray-500 text-sm mr-1">Price: </p>
                        <p className=" text-gray-600 font-bold text-sm">{` ${product.price}`}</p>
                      </div>
                    </div>
                  </div>
                </Box>
              );
            })}{" "}
            <ViewProducts
              products={this.state.modalOpen}
              isOpen={this.state.productModal}
              isClose={() => {
                this.setState({ productModal: false });
              }}
            />
          </Box>
        </Box>
      );
    }
  }
}

export default ProductPost;
